<template lang="pug">
v-list-item-group(v-model="selectedOption" active-class="active-item" :class="statusClass" :multiple="isMultiple" v-ripple="false")
    v-divider
    v-subheader(v-if="isFoodItem") {{ subGroupItem.title }}

    v-list-item(
        v-for="(optionItem, idx) in menuGroupItem.optionList" :key="idx"
        v-if="optionItem.offer && optionItem.offer.foodItem"
        :value="optionItem" :disabled="isDataDisabled(optionItem) && !reservationItem || !isFreePortion(optionItem) && !isReservation(optionItem) && isPortionControl && optionItem.offer.portionsCount !== null"
    )
        v-row.ma-0
          v-col(cols="12")
            v-row.ma-0
              v-list-item-icon.align-self-center(:class="iconClass(optionItem)")
              v-row.ma-0(v-if="!isReservation(optionItem) && !isFreePortion(optionItem) && isPortionControl && isPortionControl && optionItem.offer.portionsCount !== null")
                strike(v-if="!isReservation(optionItem) && !isFreePortion(optionItem) && isPortionControl && isPortionControl && optionItem.offer.portionsCount !== null") {{ optionItem.offer.foodItem.name }}
                v-col.pa-0.red--text(cols="12") {{ $t('orderPage.nullPortionsCount') }}
              v-list-item-content(v-else) {{ optionItem.offer.foodItem.name }}
              v-list-item-icon.slot-code.align-self-center.align-center
                  span {{ optionItem.code }}
                  //span.ml-1.offer-price
                      span (
                      span.ma-1 {{ getOfferPrice(optionItem) }}
                      span.fal.fa-euro-sign
                      span.ml-1 )
            v-row.ma-0.mt-0.pt-0(v-if="isSelectedOption(optionItem) && isMultiplePortion" )
              v-col.text-end.pa-0(cols="5"  @click.stop)
                v-btn(@click.stop="onMinusPortionButtonClick(optionItem)" fab small ripple )
                  v-icon(small) fas fa-minus
              v-col.title.pa-0.text-center(cols="2"  @click.stop) {{optionItem.offer.amount}}
              v-col.text-start.pa-0(cols="5"  @click.stop)
                v-btn(@click.stop="onPlusPortionButtonClick(optionItem)" small fab ripple)
                  v-icon(small) fas fa-plus


</template>

<script lang="ts">
import Vue from 'vue'
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";
import {Component, Prop, Watch} from "vue-property-decorator";
import MenuGroupItem from "@/model/menu/MenuGroupItem";
import Configuration from "@/model/Configuration";
import _ from 'lodash'
import MenuGroupItemOrder from "@/model/dailymenu/MenuGroupItemOrder";

@Component({
})

export default class GroupOptionSelector extends Vue {

  @Prop({type: Object as () => any, required: true}) menuGroupItem!: any
  @Prop({type: Object as () => MenuReservationItem | undefined}) reservationItem!: MenuReservationItem | undefined
  @Prop({type: Boolean, required: true}) isManipulationAllowed!: Boolean
  @Prop({type: Object as () => MenuGroupItem}) subGroupItem!: MenuGroupItem
  @Prop({type: Array as () => Configuration[]}) configuration!: Configuration[]
  @Prop({type: Array }) settingsData!: any[]
  @Prop({type: Boolean, default: false}) isMultiplePortion!: boolean
  @Prop({type: Map, required: true}) currentSelection!: Map<MenuGroupItemOrder, DailyMenuOptionOrder>

  private selectedOption: DailyMenuOptionOrder[] | DailyMenuOptionOrder | null = null

  /*getReservationAmount (id: string): number {
    let amount: number = 1
    this.currentSelection.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: MenuGroupItemOrder) => {
      if(value.offer && value.offer.id === id) {
        amount = value.offer.amount
      }
    })
    return amount
  }*/

  get statusClass(): string {
    return this.reservationItem && this.reservationItem.status || 'new-reservation'
  }

    get isFoodItem (): boolean {
      const filteredData: DailyMenuOptionOrder[] = this.subGroupItem.optionList.filter((item: DailyMenuOptionOrder) => item.offer)
      return filteredData.length > 0
    }

  get isPortionControl(): boolean {
    let condition: boolean = false
    const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_portions_count')
    if(foundItem){
      condition = foundItem.value === 'true'
    } else {
      condition = false
    }

    return condition
  }


  @Watch('menuGroupItem')
     menuItem(): void {
      this.selectedOption = null
    }

    @Watch('reservationItem')
       reservItem (): void {
          this.updateSelectedOption()
      }

    @Watch('selectedOption')
    selectO(newVal: DailyMenuOptionOrder | DailyMenuOptionOrder[] | undefined) {
      if(newVal instanceof Array) {
        if(newVal) {
          newVal.forEach((item: DailyMenuOptionOrder) => {
            let foundItem: any | null = this.reservationItem?.reservedOffers.find((i: any) => item.offer && i.dailyMenuOffer.id === item.offer!.id)
            if (foundItem) {
              item.offer!.amount = foundItem.amount
            } else {
              item.offer!.amount = 1
            }
          })
        }
      } else {
        if(newVal && newVal.offer) {
          let foundItem: any | null = this.reservationItem?.reservedOffers.find((i: any) => i.dailyMenuOffer.id === newVal.offer!.id)
          if (foundItem) {
            newVal.offer!.amount = foundItem.amount
          } else {
            newVal.offer!.amount = 1
          }
        }
      }


      this.$emit('selectedOptionChange', newVal)
    }

    isDataDisabled (data: DailyMenuOptionOrder): boolean {
      return data.offer && data.offer.portionsCount === 0 ? true : false
    }

    isFreePortion(data: any): boolean {
      return data.offer.portionsCount > data.offer.reservedPortionsCount

    }

  get isMultiple (): boolean {
    let condition: boolean = false
    this.subGroupItem.tags.forEach((i: any) =>{
      this.configuration.forEach((c: Configuration) => {
        const foundTag: any = c.tags.find((t: any) => t.id === i.id)
        if(foundTag){
          //@ts-ignore
          if(c && c.settings) {
            //@ts-ignore
            if(!c.settings['configuration_group.single_item']) {
              condition = true
            }
          }
        }
      })
    })

    return condition
  }

  isSelectedOption(option: DailyMenuOptionOrder): boolean {
    if(this.selectedOption && _.isArray(this.selectedOption)) {
      if (this.selectedOption.includes(option)) {
        return true
      } else {
        return false
      }
    } else if(this.selectedOption && _.isObject(this.selectedOption)) {
      if (this.selectedOption === option) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

    iconClass (option: DailyMenuOptionOrder): string {
      if(this.selectedOption && _.isArray(this.selectedOption)) {
        if (this.selectedOption.includes(option)) {
          return 'fa fa-check-circle'
        } else {
          return 'fa fa-ban'
        }
      } else if(this.selectedOption && _.isObject(this.selectedOption)) {
        if (this.selectedOption === option) {
          return 'fa fa-check-circle'
        } else {
          return 'fa fa-ban'
        }
      } else {
        return 'fa fa-ban'
      }

      /*if (this.selectedOption === option) {
        return 'fa fa-check-circle'
      } else {
        return 'fa fa-ban'
      }*/
    }

  isReservation (data: any): boolean {
    if(this.reservationItem && this.reservationItem.reservedOfferCollection) {
      const foundItem: any = this.reservationItem.reservedOfferCollection.find((item: any) => item.id === data.offer.id)
      return foundItem ? true : false
    } else {
      return false
    }
  }

  onPlusPortionButtonClick (option: DailyMenuOptionOrder) {
    option.offer!.amount += 1
    this.$emit('newAmount',option)
  }

  onMinusPortionButtonClick (optionItem: any) {
    if(optionItem!.offer!.amount > 1) {
      optionItem!.offer!.amount -= 1
    }
    this.$emit('newAmount',optionItem)
  }


    updateSelectedOption (): void {
      if (this.reservationItem && this.reservationItem.reservedOfferCollection) {
        const reservedOffers = this.reservationItem.reservedOfferCollection
        const relevantItems = this.menuGroupItem.optionList.filter((slotItem: any) => {
          if(slotItem.offer && slotItem.offer.id) {
          return !!reservedOffers.find((reservedOptionItem) => slotItem.offer!.id === reservedOptionItem.id)
          } else {
            return false
          }
        })

        if (relevantItems) {
          if(this.isMultiple){
            this.selectedOption = relevantItems
          } else {
            relevantItems.forEach((item: any) => {
              this.selectedOption = item
            })
          }
        } else {
          this.selectedOption = null
        }
      } else {
        this.selectedOption = null
      }
    }

    getOfferPrice(slotItem: DailyMenuOptionOrder): string {
      if (this.reservationItem) {
        const offer = this.reservationItem.reservedOffers.find(o => o.dailyMenuOffer.id === (slotItem.offer!.id as unknown as number))

        if (offer) {
          return offer.agreedUnitPrice
        }
      }

      return slotItem.offer!.price
    }


  mounted () {
    this.updateSelectedOption()
  }
}
</script>

<style lang="stylus" scoped>
.active-item
    .v-list-item__icon:first-child
        color #81ad3b

.canceled
    .active-item
        .v-list-item__icon:first-child
            color red

.slot-code
    font-size x-large

.offer-price
    font-size smaller

.currency-icon
  color rgba(0, 0, 0, 1)

</style>
